import BaseForgeCustomizer from '../base-forge';
import ProxyFooter from '../../components/common/ProxyFooter';
import React from 'react';
import { isAnetUser } from '../../utils/user-utils';

export default abstract class BaseEnrollPhoneFactorCustomizer extends BaseForgeCustomizer {
  displayFooterText = isAnetUser();

  protected getFooter({ footerLink }: { footerLink: JQuery }) {
    return (
      <ProxyFooter
        text={this.footerText}
        footerLinks={footerLink.not('[data-se=cancel]')}
        alwaysDisplayBackToSignIn={this.alwaysDisplayBackToLogin}
      />
    );
  }
}
